import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';

import { Text, useTheme } from '@/components/ui';
import { TASK_COLORS } from '@/types/models';

interface ColorPickerProps {
	value?: string;
	onValueChange: (color: string | undefined) => void;
}

export const ColorPicker: React.FC<ColorPickerProps> = ({ value, onValueChange }) => {
	const theme = useTheme();

	return (
		<View>
			<Text style={{ fontSize: 12, color: theme.colors.onSurfaceVariant, marginBottom: 4 }}>Color</Text>
			<View style={styles.row}>
				<TouchableOpacity
					onPress={() => onValueChange(undefined)}
					style={[
						styles.swatch,
						{
							backgroundColor: theme.colors.surfaceVariant,
							borderColor: !value ? theme.colors.primary : 'transparent',
							borderWidth: !value ? 2 : 1,
						},
					]}
				>
					<Text style={{ fontSize: 10, color: theme.colors.onSurfaceVariant }}>--</Text>
				</TouchableOpacity>
				{TASK_COLORS.map((c) => (
					<TouchableOpacity
						key={c.value}
						onPress={() => onValueChange(c.value)}
						style={[
							styles.swatch,
							{
								backgroundColor: c.value,
								borderColor: value === c.value ? theme.colors.primary : 'transparent',
								borderWidth: value === c.value ? 2 : 1,
							},
						]}
					/>
				))}
			</View>
		</View>
	);
};

const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
		gap: 8,
		flexWrap: 'wrap',
	},
	swatch: {
		width: 32,
		height: 32,
		borderRadius: 16,
		alignItems: 'center',
		justifyContent: 'center',
	},
});
